<script>
  import { layoutMethods,careersMethods } from "@/state/helpers";
  import Swal from 'sweetalert2';
  import { getModuleAccess } from '@/router/helper.js'
  import shortid from "shortid";

  /**
   * Job Opening List component
   */
  export default {
    page: {
      title: "Job Opening Details"
    },
    components: {
    },
    computed: {
    },
    data() {
      return {
        title: "Career Details",
        career_id: 0,
        job_details: {},
        statusOption:[
          {"value": null,"text":"Select Job Title Status", disabled:true},
          {"value":"o","text":"Open"},
          {"value":"c","text":"Close"}
        ],
        searchValue: {
            page: 1,
            rows: 10,
            sort: 'id',
            orderDesc: true,
        },
        applicantTotal: 0,
        applicantList: [],
        fields: [
          { key: "name", label: "Applicant Name", sortable: true},
          { key: "interview_sheet", label: "Interview Notes", sortable: false},
          { key: "document_src", label: "Resume", sortable: true},
          { key: "mobile_number", label: "Contact Number", sortable: true},
          { key: "email", label: "Email Address", sortable: true},
          { key: "created_at", label: "Date & Time Sent", sortable: true},
          { key: "status", label: "Applicant Status", sortable: false},
          { key: "remarks", label: "Remarks", sortable: false},
          { key: "linkedin", label: "LinkedIn", sortable: true},
          { key: "github", label: "GitHub", sortable: true},
          { key: "portfolio", label: "Portfolio", sortable: true},
          { key: "website", label: "Website", sortable: true},
        ],
        sortBy: "value",
        sortDesc: false,
        pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
        varHolder : {"status":0,"job_status":"o"},
        jobOpeningModule: {
          access: {
            create: true,
            update: true
          }
        },
        applicantStatusOption:[
          {"value": null,"text":"Select Job Status", disabled:true},
          {"value":"n","text":"New Applicant"},
          {"value":"o","text":"On-hold/In-Pipeline"},
          {"value":"r","text":"Rejected"},
          {"value":"h","text":"Hired"},
          {"value":"e","text":"Endorsed"},
        ],
        activeJobList:[],
        form:{
          file:null
        },
        interviewSheetFile : {
          filename: null,
          type: null,
          base64: null,
          applicant_id:null
        },
      };
    },
    methods: {
      ...layoutMethods,
      ...careersMethods,
      async getJobDetails(){
        await this.actionCareers({
            action: "job-details",
            body: {"career_id":this.career_id,"type":"view"}
        })
        .then((res) => {
          console.log(res);
          this.job_details = {...res["message"]}
          this.varHolder.status = res["message"]["status"]
          this.varHolder.job_status = res["message"]["job_status"]
          this.job_details.hiring_manager_email = this.job_details.hiring_manager_email.split(",");
        }).catch((e)=>{
          console.log("error while getting job details",e);
        });
      },
      async getJobApplicants(state=''){
        if(state == 'reset'){
          this.searchValue.page = 1;
        }
        await this.actionCareers({
            action: "applicant-list",
            body: {...this.searchValue,"career_id":this.career_id}
        })
        .then((res) => {
          console.log(res);
          this.applicantTotal =res["message"]["pageInfo"]["total"] 
          this.applicantList = res["message"]["rows"]
          for(let a of this.applicantList){
            a["org_status"] = a["status"]
          }
        }).catch((e)=>{
          console.log("error while getting job details",e);
        });
      },
      tableSorting(ctx){//context
        this.searchValue.sort = ctx.sortBy;
        this.searchValue.orderDesc = ctx.sortDesc;
        this.getJobApplicants('reset');
      },
      updateSpecificDetail(type){
        Swal.fire({
          title: type == "status"? 
                (this.job_details["status"] == 1? "Enable":"Disable") + " Job Opening":
                (this.job_details["job_status"] == "o"? "Open":"Close") + " Job Status",
          text: `Are you sure you want to proceed?`,
          icon: "question",
          showCancelButton: true,
          cancelButtonText: "No",
          confirmButtonColor: "#c4297c",
          cancelButtonColor: "#804997",
          confirmButtonText: "Yes",
        }).then((result) => {
          if (result.value) {
            this.actionCareers({
                action: "update-status",
                body: {
                  "career_id" :this.career_id,
                  "status"    :this.job_details["status"],
                  "job_status":this.job_details["job_status"],
                }
            })
            .then((res) => {
              Swal.fire(
                "Updated Successful!",
                `${this.job_details["job_title"]} has been updated.`,
                "success"
              );
              console.log(res);
              this.getJobDetails();
            }).catch((e)=>{
              console.log("error while update job status",e);
            });
          }else{
            this.job_details.status = this.varHolder.status
            this.job_details.job_status = this.varHolder.job_status
          }
        });
      },
      statusCompletor(s){
        var str = null;
        switch (s) {
          case "n":
            str = "New Applicant"
            break;
          case "o":
            str = "On-hold/In-Pipeline"
            break;
          case "r":
            str = "Reject"
            break;
          case "h":
            str = "Hire"
            break;
          default:
            break;
        }
        return str;
      },
      async confirmUpdateApplicantStatus(applicant){
        console.log("Hello applicant",JSON.stringify(applicant));
        if(applicant.status == "r"){
          Swal.fire({
            title: "Applicant Status",
            text: `Are you sure you want to reject ${this.toTitleCase(applicant.name)}?`,
            input: 'text',
            inputPlaceholder: "Enter a remarks...",
            icon: "question",
            showCancelButton: true,
            cancelButtonText: "No",
            confirmButtonColor: "#c4297c",
            cancelButtonColor: "#804997",
            confirmButtonText: "Yes",
          }).then((result) => {
            console.log("SWAL",JSON.stringify(result));
            if (result.value) {
              applicant.remarks = result.value;
              this.updateApplicantStatus(applicant);
            }else{
              applicant.status = applicant.org_status
            }
          });
        }
        else if(applicant.status == "e"){
          var self = this;
          await this.getActiveJobs().then(function(){
            var inputOptions = {};
            for(let i = 0; i < self.activeJobList.length; i++){
              var j = self.activeJobList[i];
              console.log(JSON.stringify(j));
              inputOptions[i] = self.toTitleCase(j["job_title"]);
            }
            Swal.fire({
              title: "Applicant Status",
              text: `Are you sure you want to endorse ${self.toTitleCase(applicant.name)}?`,
              input: 'select',
              inputOptions: inputOptions,
              inputPlaceholder: 'Please select job title',
              icon: "question",
              showCancelButton: true,
              cancelButtonText: "No",
              confirmButtonColor: "#c4297c",
              cancelButtonColor: "#804997",
              confirmButtonText: "Yes",
            }).then((result) => {
              console.log("SWAL",JSON.stringify(result));
              if (result.value) {
                applicant.remarks = self.activeJobList[result.value];
                self.updateApplicantStatus(applicant);
              }else{
                applicant.status = applicant.org_status
              }
            });
          });
        }else{
          Swal.fire({
            title: "Applicant Status",
            text: `Are you sure you want to change status of ${this.toTitleCase(applicant.name)} from ${this.statusCompletor(applicant.org_status)} to ${this.statusCompletor(applicant.status)}?`,
            icon: "question",
            showCancelButton: true,
            cancelButtonText: "No",
            confirmButtonColor: "#c4297c",
            cancelButtonColor: "#804997",
            confirmButtonText: "Yes",
          }).then((result) => {
            if (result.value) {
              this.updateApplicantStatus(applicant);
            }else{
              applicant.status = applicant.org_status
            }
          });
        }
      },
      updateApplicantStatus(applicant){
        this.actionCareers({
            action: "update-applicant-status",
            body: {
              "career_id" :applicant["career_id"],
              "applicant_id":applicant["id"],
              "status"    :applicant["status"],
              "remarks"   :applicant["remarks"],
            }
        })
        .then((res) => {
          if(applicant["status"] == "e"){
            applicant["remarks"] = null;
          }
          Swal.fire(
            "Updated Successful!",
            `${this.toTitleCase(applicant["name"])} has been updated.`,
            "success"
          );
          console.log(res);
        }).catch((e)=>{
          console.log("error while update applicant status",e);
          Swal.fire(
            "Update Failed!",
            `${this.toTitleCase(applicant["name"])} can't update.`,
            "warning"
          );
          applicant.status = applicant.org_status
          applicant.remarks = null
        });
      },
      toTitleCase(str) {
        return str.replace(
          /\w\S*/g,
          function(txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
          }
        );
      },
      async getActiveJobs(){
        await this.actionCareers({
            action: "active-job-list",
            body: {}
        })
        .then((res) => {
          console.log(res);
          this.activeJobList = res.message
        }).catch((e)=>{
          console.log("error while getting job list",e);
        });
      },
      uploadInterviewSheet(applicant){
        this.clearFileUpload();
        if(applicant.interview_sheet_src != null){
          Swal.fire({
              title: `Upload Interview Sheet`,
              text: `${applicant.name} has existing interview sheet want to override it?`,
              icon: 'question',
              showCancelButton: true,
              confirmButtonColor: '##804997',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes',
              cancelButtonText: 'No'
          }).then((result) => {
              if (result.isConfirmed) {
                  this.interviewSheetFile.applicant_id = applicant.id;
                  document.getElementById("interviewSheetUpload").click()
              }else{
                  return;
              }
          })
        }else{
            this.interviewSheetFile.applicant_id = applicant.id;
            document.getElementById("interviewSheetUpload").click()
        }
      },
      onFileChange(e){
        const reader = new FileReader();
        var files = e.target.files || e.dataTransfer.files;

        if (!files.length){
          this.clearFileUpload();
          return;
        }

        reader.onloadend = () => {
          var base64Data = reader.result;
          this.interviewSheetFile.type = base64Data.split(';')[0].split('/')[1];

          if(this.compareStr(this.interviewSheetFile.type,["vnd.openxmlformats-officedocument.wordprocessingml.document"])){
            this.interviewSheetFile.base64 = new Buffer.from(base64Data.replace(/^data:application\/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,/, ''), 'base64');
          }
          if(this.compareStr(this.interviewSheetFile.type,["vnd.openxmlformats-officedocument.spreadsheetml.sheet"])){
            this.interviewSheetFile.base64 = new Buffer.from(base64Data.replace(/^data:application\/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,/, ''), 'base64');
          }
          
          this.interviewSheetFile.filename = `${shortid.generate()}.${this.interviewSheetFile.type}`;
          console.log(this.interviewSheetFile);
          if(this.compareStr(this.interviewSheetFile.type,["vnd.openxmlformats-officedocument.wordprocessingml.document","vnd.openxmlformats-officedocument.spreadsheetml.sheet"]) === false){
              this.clearFileUpload();
              this.form.file = null;
            Swal.fire("Invalid supporting document!", `doc or excel file is required`, "error");
          }else{
            this.uploadInterviewSheetPrep();
          }
        }
        reader.readAsDataURL(files[0]);
      },
      compareStr(data, arr_similar){// case insensitive string comparison
        for(var i = 0; i < arr_similar.length; i++){
            var areEqual = data.toUpperCase() === arr_similar[i].toUpperCase();
              if(areEqual){
                return areEqual;
              }
          }
          return false;
      },
      clearFileUpload(){
        this.interviewSheetFile = {
          filename: null,
          type: null,
          base64: null,
          applicant_id:null
        }
      },
      uploadInterviewSheetPrep(){
        if(this.interviewSheetFile.base64){
          var interviewSheetFile = { ...this.interviewSheetFile };

          this.putInterviewSheet(interviewSheetFile)
            .then((imageKey) => {
              for(let i of this.applicantList){
                if(i.id == interviewSheetFile.applicant_id){
                  i["interview_sheet_src"] = imageKey;
                  this.updateApplicantInterviewSheet(i)
                }
              }
            })
            .catch((err) => {
              Swal.fire("Upload Failed!",`${err}`, "error");
            });
        }
      },
      updateApplicantInterviewSheet(applicant){
        this.actionCareers({
            action: "update-applicant-interview-sheet",
            body: {
              applicant_id  : applicant["id"],
              career_id     : applicant["career_id"],
              interview_sheet_src : applicant["interview_sheet_src"]
            }
        })
        .then((res) => {
          applicant.interviewSheetSignUrl = res.message
          console.log("updateApplicantInterviewSheet",JSON.stringify(res));
        }).catch((e)=>{
          console.log("error updateApplicantInterviewSheet",JSON.stringify(e));
        });
      },
    },
    async mounted(){
      this.changeTitle({title: 'Careers'});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'} },
          { text: 'Careers', to: { name: 'Job Opening'} },
          { text: 'Job Opening', to: { name: 'Job Opening'} },
          { text: 'Details', to: { name: 'View Job Opening'} }
        ]
      });
      this.career_id = this.$route.params.id;
      if(this.career_id > 0){
        await this.getJobDetails();
        await this.getJobApplicants();
      }

      // get the module access for checking if user has create, read, update, and/or delete access
      await getModuleAccess('Utilities', 'Careers', 'Job Opening')
        .then((access) => this.jobOpeningModule.access = access);
    }
  }
    
</script>

<template>
  <div><!-- outer div-->
      <div class="row">
          <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                      <div class="col-md-12 mb-3"><!--start active status-->
                        <div class="form-check form-switch">
                          <label class="form-check-label" for="flexSwitchCheckDefault">Active</label>
                          <input
                            :disabled="!jobOpeningModule.access.update"
                            class="form-check-input"
                            v-model="job_details.status"
                            type="checkbox"
                            id="flexSwitchCheckDefault"
                            @change="updateSpecificDetail('status')"
                          />
                        </div>
                      </div><!--end active status-->
                      <div class="mb-3 col-md-10 pt-2"><!--job title-->
                        <h4 class="text-capitalize">
                          {{ job_details.job_title }}
                        </h4>
                        <p class="text-capitalize">
                          <span class="me-3">
                            <i class="bx bx-calendar text-primary"></i> Date & Time Created: {{ job_details.created_at | formatDateNoComma }}
                          </span>
                          <span v-if="job_details.reactivated_at != null">
                            <i class="bx bx-calendar text-secondary"></i> Date & Time Reactivated: {{ job_details.reactivated_at | formatDateNoComma }}
                          </span>
                        </p>
                      </div><!--job title-->
                      <div class="col-md-2 mb-3"><!--Job status-->
                        <label class="form-label small">Job Status</label>
                        <b-form-select
                          class="form-control w-75 border"
                          placeholder="Select Status here"
                          v-model="job_details.job_status"
                          :options="statusOption"
                          :class="{
                              'border-success': job_details.job_status == 'o',
                              'border-danger': job_details.job_status == 'c',
                          }"
                            @change="updateSpecificDetail('job_status')"
                        />
                      </div><!--job status-->
                      <div class="mb-1 col-md-12"><!--job description-->
                        <!-- <div v-html="job_details.job_description"></div> -->
                        <p class="text-justify" style="white-space: break-spaces;">{{job_details.job_description}}</p>
                      </div><!--job description-->
                      <div class="col-md-12"><hr></div>
                      <div class="col-md-12 row"><!--job other-->
                        <div class="col-4">
                          Employment Type: 
                          <span class="text-primary text-capitalize">
                            {{ job_details.type }}
                          </span>
                        </div>
                        <div class="col-3">
                          Location: 
                          <span class="text-primary text-capitalize">
                            {{ job_details.location }}
                          </span>
                        </div>
                        <div class="col-3">
                          Work Shift: 
                          <span class="text-primary text-capitalize">
                            {{ job_details.work_shift }}
                          </span>
                        </div>
                        <div class="col-2">
                          Work Set-up: 
                          <span class="text-primary text-capitalize">
                            {{ job_details.work_setup }}
                          </span>
                        </div>
                      </div><!--job other-->
                      <div class="col-md-12"><hr></div>
                      <div class="col-md-6"><!--job roles-->
                        <b>Role Responsibilities:</b> <br>
                        <div class=" overflow-auto" v-html="job_details.role_resp"></div>
                      </div><!--job roles-->
                      <div class="col-md-6"><!--job requirements-->
                        <b>Job Requirements:</b>
                        <div class=" overflow-auto" v-html="job_details.job_requirements"></div>
                      </div><!--job requirements-->
                      <div class="col-md-12"><hr></div>
                      <div class="col-md-12 row"><!--job other-->
                        <div class="col-5">
                          Department Name: 
                          <span class="text-primary text-capitalize">
                            {{ job_details.department }}
                          </span>
                        </div>
                        <div class="col-7">
                          Hiring Manager: 
                          <span class="badge badge-outline-primary me-1 badge-secondary"  v-for="email in job_details.hiring_manager_email" :key="email">
                            {{ email }}
                          </span>
                        </div>
                      </div><!--job other-->
                      <div class="col-md-12"><hr></div>
                      <div class="col-md-12 mt-3 ta-right p-0">
                        <router-link :to="{ name: `${!jobOpeningModule.access.update ? 'View Job Opening' : 'Add Job Opening'}`, params:{id: job_details.id}}" class="tc-white"
                          :disabled="!jobOpeningModule.access.update">
                          <b-button :disabled="!jobOpeningModule.access.update" variant="primary" class="w-sm me-2" type="submit">Edit</b-button>
                        </router-link>
                        <router-link :to="{ name: 'Job Opening'}" class="tc-white">
                          <b-button variant="light" class="w-sm ml-2" type="button" >Close</b-button>
                        </router-link>
                      </div>
                    </div><!--end of inner row-->
                </div>
                <!-- end card body -->
            </div>
            <!-- end card -->
          </div><!-- end col-lg-12 -->
      </div><!-- end of row-->


      <div class="row">
          <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <div class="row mb-3">
                        <div class="col-md-12 col-sm-4">
                            <div class="my-2">
                                <h5 class="card-title text-dark">
                                    Applicants:
                                    <span class="badge bg-secondary me-1 badge-secondary p-2">{{applicantTotal}}</span>
                                </h5>
                            </div>
                        </div>

                        <div class="table-responsive">
                          <div class="table align-middle table-nowrap">
                            <b-table
                              :items="applicantList"
                              :fields="fields"
                              responsive="sm"
                              :current-page="searchValue.page"
                              :sort-by.sync="sortBy"
                              :sort-desc.sync="sortDesc"
                              @sort-changed="tableSorting"
                              class="table-check"
                            >
                              <template #cell(name)="data">
                                <span class="text-capitalize">
                                  {{ data.item.name}}
                                </span>
                              </template>
                              <template #cell(created_at)="data">
                                {{ data.item.created_at | formatDate }}
                              </template>
                              <template #cell(document_src)="data">
                                  <a :href="data.item.documentSignUrl" target="_blank" v-if="data.item.documentSignUrl != null" class="pull-right">
                                    <i class="uil-file-alt"></i> Link here
                                  </a> 
                                  <span v-else>
                                    {{ data.item.document_src }}
                                  </span>
                              </template>
                              <template #cell(remarks)="data">
                                <p v-bind:title='data.item.remarks'>{{data.item.remarks == null ? "--" : data.item.remarks | truncator(20,'...')}}</p>
                              </template>
                              <template #cell(status)="data">
                                <b-form-select
                                  class="form-control" 
                                  placeholder="Select Applicant Status"
                                  v-model="data.item.status" 
                                  :options="applicantStatusOption"
                                  :class="{
                                      'border-success': data.item.status == 'h',
                                      'border-danger': data.item.status == 'r',
                                      'border-warning': data.item.status == 'n',
                                      'border-secondary': data.item.status == 'o',
                                  }"
                                  @change="confirmUpdateApplicantStatus(data.item)"
                                />
                              </template>
                              <template #cell(interview_sheet)="data">
                                  <div v-if="data.item.interviewSheetSignUrl != null" class="pull-right" style="padding-left: 35px;">
                                    <a :href="data.item.interviewSheetSignUrl" target="_blank" v-if="data.item.interviewSheetSignUrl != null">
                                      <i class="uil-file-alt"></i> Link here
                                    </a> 
                                  </div>
                                  <b-button variant="outline-secondary" class="btn-sm me-2" type="button" @click="uploadInterviewSheet(data.item)"><i class="bx bx-upload"></i></b-button>
                                  <b-form-file
                                    id="interviewSheetUpload"
                                    class="form-control"
                                    type="file"
                                    v-model="form.file"
                                    @change="onFileChange"
                                    plain
                                    hidden
                                  />
                              </template>
                            </b-table>
                          </div>
                        </div>
                        <div class="row g-0 text-center" v-if="applicantTotal == 0">
                          <span>No data to display.</span>
                        </div>

                        <div class="row" v-if="applicantTotal > 0">
                          <div class="col">
                            <div class="form-group row pull-left">
                              <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                              <div class="col-sm-6">
                                <b-form-group label-for="display-record">
                                  <b-form-select class="form-select shadow-none w-fit"
                                    id="display-record"
                                    v-model="searchValue.rows"
                                    :options="pageOptions"
                                    @change="getJobApplicants('reset')"
                                  ></b-form-select>
                                </b-form-group>
                              </div>
                            </div>
                            <div
                              class="
                                dataTables_paginate
                                paging_simple_numbers
                                float-end
                              "
                            >
                              <b-pagination
                                v-if="applicantTotal != 0 && applicantTotal > searchValue.rows"
                                class="pagination-rounded"
                                v-model="searchValue.page"
                                :total-rows="applicantTotal"
                                @input="getJobApplicants()"
                                :per-page="searchValue.rows"
                              ></b-pagination>
                            </div>
                          </div>
                        </div>
                    </div><!--end of inner row-->
                </div>
                <!-- end card body -->
            </div>
            <!-- end card -->
          </div><!-- end col-lg-12 -->
      </div><!-- end of row-->
  </div> <!-- end of outer div-->
</template>